import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import VueStorage from 'vue-ls'
import { VueAxios } from './utils/request'
import 'bootstrap337/dist/css/bootstrap.min.css'
import 'bootstrap337/dist/js/bootstrap.min'
import "./assets/components/icon-font/iconfont.css"
import "./assets/css/public.css"

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  /* 需要注册百度地图开发者来获取你的ak */
  ak: 'NDQeI6jAlM2Z5M5EmzpbEf0LgD7Usiqc'
})

Vue.config.productionTip = false
Vue.use(VueStorage)
Vue.use(VueAxios)
axios.defaults.withCredentials = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
